import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ClinicViewPage } from '@frontend/features/provider-network/pages/ClinicViewPage';
import type { ClinicTab } from '@frontend/features/provider-network/types/providerNetwork.types';

// Create a type-safe validator for the tab search parameter
const tabValues: [ClinicTab, ...ClinicTab[]] = [
  'general',
  'contacts',
  'features',
  'contract',
  'components',
  'note',
  'credentials',
  'documents',
  'providers',
];

export const Route = createFileRoute('/provider-network/clinic/$clinicId/')({
  component: ClinicViewPage,
  validateSearch: z.object({
    tab: z.enum(tabValues).optional(),
    // Preserve return location and search state for back navigation
    returnTo: z.string().optional(),
    returnSearch: z.any().optional(),
  }),
});
